import http from 'utils/http';
import { getContactsUrl, getContactUrl, getNotesUrl, getNoteUrl } from './apiUrls';
import { ContactRequest, ContactResponse, NoteRequest, NotesResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getContacts(params?: object): Promise<{ data: ContactResponse[]; meta: MetaApiResponse }> {
  return http.get(getContactsUrl(), params);
}

export function getContact(id: number, params?: object): Promise<ContactResponse> {
  return http.get(getContactUrl(id), params);
}

export function createContact(payload: ContactRequest): Promise<ContactResponse> {
  return http.post(getContactsUrl(), payload);
}

export function updateContact(id: number, payload: ContactRequest): Promise<{ meta: { message: string } }> {
  return http.patch(getContactUrl(id), payload);
}

export function getNotes(id: number, params?: object): Promise<{ data: NotesResponse[]; meta: MetaApiResponse }> {
  return http.get(getNotesUrl(id), params);
}

export function createNote(id: number, payload?: NoteRequest): Promise<NotesResponse> {
  return http.post(getNotesUrl(id), payload);
}

export function updateNote(contactId: number, id: number, payload?: NoteRequest): Promise<NotesResponse> {
  return http.put(getNoteUrl(contactId, id), payload);
}

export function deleteNote(contactId: number, id: number, payload?: NoteRequest): Promise<NotesResponse> {
  return http.delete(getNoteUrl(contactId, id), payload);
}
